<template>
  <div>
    <!-- <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-3 pb-3">
      {{ !form.payLater ? 'Data da reserva' : 'Data da cotação' }}
    </legend> -->
    <div
      v-show="HIDE_CALENDAR"
      class="text-left w-100 pt-0 pb-0"
      style="font-size: 14px; font-weight: 500"
    >
      <div class="pl-2">
        <template v-if="isConfirmedDeparture()">
          {{ formattedDate(form.date, 'DD/MM/YYYY') }}
          <button
            type="button"
            class="btn btn-link p-0 ml-1 align-baseline"
            title="Exibir calendário"
            @click="showCalendar"
          >
            <i class="fas fa-pencil-alt" aria-hidden="true"></i>
          </button>
        </template>
        <template v-else-if="isQuoteTodayMode()">
          <div>Cotação para hoje</div>
          <div>{{ formattedDate(form.date, 'DD/MM/YYYY') }}</div>
        </template>
        <template v-else>
          {{ formattedDate(form.date, 'DD/MM/YYYY') }}
          <i
            class="fa fa-info-circle"
            title="Reservas com auto checkin só podem ser registradas para o horário disponível mais próximo!"
            aria-hidden="true"
          ></i>
        </template>
        <div v-if="form.auto_checkin_blocked" class="text-danger pt-1">
          {{
            isQuoteTodayMode()
              ? todayBlockLabel()
              : 'Sem vagas disponíveis para hoje'
          }}
        </div>
      </div>
    </div>
    <b-calendar
      v-model="form.date"
      v-show="!HIDE_CALENDAR"
      :min="calendarMin"
      :date-disabled-fn="disabledDates"
      selected-variant="success"
      nav-button-variant="success"
      today-variant="info"
      locale="pt-BR"
      hide-header
      no-key-nav
      label-help=""
      class="border-0 border-dark"
    >
    </b-calendar>

    <!-- <legend
      v-if="
        currentDateBookingTimes[0] &&
        currentDateBookingTimes[0]['close'] != '00:00'
      "
      tabindex="-1"
      class="bv-no-focus-ring col-form-label pt-5 pb-2"
    >
      Horários disponíveis
    </legend> -->

    <div
      v-if="showHoraryBlock"
      class="text-center w-100 pt-4 pb-0"
      style="overflow: hidden"
      :style="currentDateBookingTimes.length > 2 ? 'width: 25%' : 'width: 100%'"
    >
      <div class="pt-2 pl-2 pb-1 horary-scroll d-flex justify-content-center">
        <div
          v-for="(horary, idx) in currentDateBookingTimes"
          :key="idx"
          class="pr-3 pb-3"
        >
          <b-button
            @click="selectHorary(horary, idx)"
            :disabled="isHoraryDisabled(horary)"
            :pressed="form.time == horary.start"
            variant="basic"
            class="rounded"
          >
            {{ formattedDate(horary.start, 'H', 'time') + 'h' }} às
            {{ formattedDate(horary.end, 'H', 'time') + 'h' }}

            <div v-if="getDateCapacity(horary) > 0">
              <hr class="mt-0 mb-0" />
              {{
                getDateCapacity(horary) > 0
                  ? getDateCapacity(horary) + ' vagas'
                  : ''
              }}
            </div>

            <div v-else>
              <span style="color: red">esgotado</span>
            </div>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { isReservationManager } from '@/store/utils/reservationManager'

export default {
  name: 'CalendarForm',

  props: {
    HIDE_CALENDAR: {
      type: Boolean,
      default: false,
    },
    payLater: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      unavailableDates: {},
      availableDates: {},
      tickets: [],
      autoCheckinBlockNotified: false,
      availabilityLoaded: false,
      pinnedPastStart: '',
      daysOfWeek: [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
      ],
    }
  },

  watch: {
    ['form.date'](newValue, oldValue) {
      if (this.isQuoteTodayMode()) {
        const today = moment().format('YYYY-MM-DD')
        const incoming = moment(newValue).format('YYYY-MM-DD')
        if (newValue && incoming !== today) {
          this.form.date = today
          return
        }
      }
      if (newValue) {
        var vm = this
        this.tickets = [...this.form.tickets]
        this.tickets.map(function (value, index) {
          value.blocked = false
        })
        this.form.time = ''
        this.pinnedPastStart = ''
        this.getUnavailableDates()
        this.getAvailableDates()

        if (Object.keys(this.unavailableDates).includes(this.form.date)) {
          this.unavailableDates[this.form.date].map(function (value, index) {
            if (value.ticket) {
              var ticketIndex = vm.tickets.findIndex(
                (ticket) => ticket.id == value.ticket
              )
              if (ticketIndex >= 0) {
                vm.tickets[ticketIndex].blocked = true
                vm.tickets[ticketIndex].quantity = 0
              }
            }
          })
        }
      }
    },

    ['form.booking_slug'](newValue, oldValue) {
      if (newValue) {
        var vm = this
        this.tickets = [...this.form.tickets]
        this.tickets.map(function (value, index) {
          value.blocked = false
        })

        if (
          !this.isReservationManager &&
          !this.isConfirmedDateLocked() &&
          (this.form.date < this.days_in_advance_avaiability.date_in_advance ||
            this.form.date > this.days_in_advance_avaiability.date_from_today)
        ) {
          if (this.isQuoteTodayMode()) {
            const today = moment().format('YYYY-MM-DD')
            if (this.form.date !== today) {
              this.form.date = today
            }
          } else {
            vm.$notify({
              message:
                'reservas a partir de ' +
                moment(this.days_in_advance_avaiability.date_in_advance).format(
                  'DD/MM/YYYY'
                ),
              duration: 8000,
              type: 'warning',
            })
            this.form.date = this.days_in_advance_avaiability.date_in_advance

            if (this.isAutoCheckinMode()) {
              this.form.date = moment().format('YYYY-MM-DD')
            }
          }
        }

        this.form.time = ''
        this.pinnedPastStart = ''
        this.getUnavailableDates()
        this.getAvailableDates()

        if (Object.keys(this.unavailableDates).includes(this.form.date)) {
          this.unavailableDates[this.form.date].map(function (value, index) {
            if (value.ticket) {
              var ticketIndex = vm.tickets.findIndex(
                (ticket) => ticket.id == value.ticket
              )
              if (ticketIndex >= 0) {
                vm.tickets[ticketIndex].blocked = true
                vm.tickets[ticketIndex].quantity = 0
              }
            }
          })
        }
      }
    },
  },

  computed: {
    ...mapGetters('booking', {
      form: 'getReservaForm',
    }),
    ...mapGetters('auth', {
      user: 'user',
      params: 'params',
    }),
    ...mapGetters('product', {
      poisList: 'getPois',
    }),

    isReservationManager() {
      return isReservationManager({
        params: this.params,
        user: this.user,
        poisList: this.poisList,
        atrativo: this.form.atrativo,
      })
    },

    calendarMin() {
      return this.isReservationManager ? '2000-01-01' : new Date()
    },

    showHoraryBlock() {
      if (!this.currentDateBookingTimes[0]) return false
      if (this.isReservationManager) return true
      return this.currentDateBookingTimes[0]['close'] != '00:00'
    },

    currentTicketsIds() {
      return this.form.tickets.map((ticket) => ticket.id)
    },

    days_in_advance_avaiability() {
      var booking_slug = this.form.booking_slug
      var special_price = this.form.atrativo.special_prices
        ? this.form.atrativo.special_prices[0].find(
            (price) => price.slug == booking_slug
          )
        : {}
      var days_in_advance = Number(special_price.days_in_advance)
      var date_in_advance = moment()
        .add(days_in_advance, 'days')
        .format('YYYY-MM-DD')
      var days_from_today = Number(special_price.days_from_today) - 1
      var date_from_today = moment()
        .add(days_from_today, 'days')
        .format('YYYY-MM-DD')

      return {
        days_from_today: days_from_today,
        date_from_today: date_from_today,
        days_in_advance: days_in_advance,
        date_in_advance: date_in_advance,
      }
    },

    currentDateBookingTimes() {
      var bookingDateTimes = [{ start: '08:00', end: '18:00', blocked: false }]
      const vm = this
      var currentDate = moment(this.form.date).format('YYYY-MM-DD')
      if (this.form.date) {
        // If currentDate is in availableDates array, bookingDateTimes receives availableDates[currentDate] structure of start/end value
        if (Object.keys(this.availableDates).includes(currentDate)) {
          bookingDateTimes = this.availableDates[currentDate]
        } else if (this.isReservationManager) {
          const slots = this.scheduleSlotsForDate(currentDate)
          if (slots.length) bookingDateTimes = slots
        }

        // If currentDate is in unavailableDates array, it must verify which one of the dates are blockable
        if (Object.keys(this.unavailableDates).includes(currentDate)) {
          this.unavailableDates[currentDate].map(function (blockedDate, index) {
            // If its the same start it blocks the whole bookingDateTimes
            var bookingDateTimesIndex = bookingDateTimes.findIndex(
              (block) => block.start == blockedDate.start
            )
            if (bookingDateTimesIndex >= 0) {
              bookingDateTimes[bookingDateTimesIndex].blocked = true
            }
          })
        }

        if (currentDate == moment().format('YYYY-MM-DD')) {
          bookingDateTimes.map((block, idx) => {
            if (block.end < moment().format('HH:mm')) {
              bookingDateTimes[idx].blocked = true
            }
          })
        }

        var bookingDateTimesIndex = bookingDateTimes.findIndex(
          (block) => !block.blocked
        )

        if (this.locksDateToToday() && !this.availabilityLoaded) {
          this.form.time = ''
          return bookingDateTimes
        }

        if (
          this.locksDateToToday() &&
          !this.hasDayAvailability(bookingDateTimes)
        ) {
          this.blockAutoCheckinReservation()
          this.form.time = ''
          return bookingDateTimes
        }

        if (this.locksDateToToday()) {
          this.unblockAutoCheckinReservation()
        }

        if (
          bookingDateTimesIndex < 0 &&
          !this.isReservationManager &&
          !this.locksDateToToday() &&
          !this.isConfirmedDateLocked()
        ) {
          let nextDay = Object.keys(vm.availableDates).filter(
            (date, index) => date > moment().format('YYYY-MM-DD')
          )

          delete this.availableDates[moment().format('YYYY-MM-DD')]

          if (
            nextDay[0] != undefined &&
            this.form.date == moment().format('YYYY-MM-DD')
          ) {
            nextDay = nextDay[0]
            setTimeout(
              (d) => {
                if (vm.isQuoteTodayMode()) return
                this.form.date = d
                vm.$notify({
                  title: 'Limite de horário!',
                  message:
                    'Não há horários disponíveis para hoje. Reservas disponíveis a partir de ' +
                    moment(d).format('DD/MM/YYYY'),
                  duration: 8000,
                  showClose: true,
                  type: 'warning',
                })
              },
              0,
              nextDay
            )
          }
        }

        //TODO: bloquear por capacidade aqui
      }

      if (this.keepsPinnedPastBlock(bookingDateTimes)) {
        this.form.time = this.pinnedPastStart
        return bookingDateTimes
      }

      let bookingTime = bookingDateTimes.find((hour) => {
        if (this.isReservationManager) return true
        if (hour.blocked) return false
        if (this.locksDateToToday()) {
          return this.slotHasCapacity(hour)
        }
        return true
      })
      this.form.time = ''
      if (bookingTime) {
        this.form.time = bookingTime.start
      }

      if (
        !this.isReservationManager &&
        !this.locksDateToToday() &&
        !this.isConfirmedDateLocked() &&
        ((bookingDateTimes.length === 1 &&
          this.getDateCapacity(bookingDateTimes[0], this.form.date) <= 0) ||
          this.availableDates[this.form.date] == undefined)
      ) {
        let nextDay = Object.keys(vm.availableDates).filter(
          (date, index) => date > this.form.date
        )
        if (
          nextDay[0] != undefined &&
          this.form.date != moment().format('YYYY-MM-DD')
        ) {
          nextDay = nextDay[0]
          setTimeout(
            (d) => {
              if (vm.isQuoteTodayMode()) return
              if (this.unavailableDates[this.form.date] == undefined) {
                vm.$notify({
                  title: 'Limite de vagas atingido!',
                  message: `Não há horários disponíveis em ${moment(
                    this.form.date
                  ).format(
                    'DD/MM/YYYY'
                  )}. Reservas disponíveis a partir de ${moment(d).format(
                    'DD/MM/YYYY'
                  )}`,
                  duration: 8000,
                  showClose: true,
                  type: 'error',
                })
              }
              this.form.date = d
            },
            0,
            nextDay
          )
        }
      }
      return bookingDateTimes
    },
  },

  methods: {
    ...mapActions('booking', ['bookingStoreCommit']),

    isPastDate(date) {
      const value = moment(date || this.form.date).format('YYYY-MM-DD')
      return value < moment().format('YYYY-MM-DD')
    },

    isPastHorary(horary) {
      if (!horary || !horary.end || !this.form.date) return false
      const date = moment(this.form.date).format('YYYY-MM-DD')
      if (date !== moment().format('YYYY-MM-DD')) return false
      return horary.end < moment().format('HH:mm')
    },

    isHoraryDisabled(horary) {
      if (this.isReservationManager) return false
      return horary.blocked || this.getDateCapacity(horary) <= 0
    },

    scheduleSlotsForDate(date) {
      const availability =
        (this.form.atrativo && this.form.atrativo.availability) || {}
      const weekday = this.daysOfWeek[moment(date).weekday()]
      const match = Object.entries(availability).find(
        (entry) => String(entry[0]).toLowerCase() === weekday
      )
      let slots = match && Array.isArray(match[1]) ? match[1] : null
      if (!slots || !slots.length) {
        const first = Object.values(availability).find(
          (value) => Array.isArray(value) && value.length
        )
        slots = first || []
      }
      return JSON.parse(JSON.stringify(slots))
    },

    keepsPinnedPastBlock(bookingDateTimes) {
      if (!this.isReservationManager || !this.pinnedPastStart) return false
      const selected = bookingDateTimes.find(
        (hour) => hour.start == this.pinnedPastStart
      )
      return !!(selected && this.isPastHorary(selected))
    },

    isAutoCheckinMode() {
      return this.form.auto_checkin === true
    },

    isQuoteTodayMode() {
      return this.form.quote_today === true
    },

    isConfirmedDeparture() {
      const value = this.form && this.form.booking_date
      return moment(value, 'YYYY-MM-DD', true).isValid()
    },

    isConfirmedDateLocked() {
      return this.isConfirmedDeparture() && this.HIDE_CALENDAR
    },

    showCalendar() {
      this.$emit('show-calendar')
    },

    locksDateToToday() {
      return this.isAutoCheckinMode() || this.isQuoteTodayMode()
    },

    isTodayOutsideAdvance() {
      try {
        const advance = this.days_in_advance_avaiability
        if (!advance || !advance.date_in_advance) return false
        const today = moment().format('YYYY-MM-DD')
        return (
          today < advance.date_in_advance || today > advance.date_from_today
        )
      } catch (error) {
        return false
      }
    },

    todayBlockLabel() {
      if (this.isTodayOutsideAdvance()) {
        return 'Hoje está fora da antecedência'
      }
      return 'Sem vagas disponíveis para hoje'
    },

    slotHasCapacity(horary, date) {
      const capacity = this.getDateCapacity(horary, date)
      return Number(capacity) > 0
    },

    hasDayAvailability(bookingDateTimes) {
      const currentDate = moment(this.form.date).format('YYYY-MM-DD')
      if (!this.availableDates[currentDate]) {
        return false
      }
      return (bookingDateTimes || []).some(
        (hour) => !hour.blocked && this.slotHasCapacity(hour, currentDate)
      )
    },

    blockAutoCheckinReservation() {
      this.$emit('blockReservation', true)
      if (this.autoCheckinBlockNotified) return
      this.autoCheckinBlockNotified = true
      const quoteToday = this.isQuoteTodayMode()
      this.$nextTick(() => {
        this.$set(this.form, 'auto_checkin_blocked', true)
        this.$notify({
          title: quoteToday ? 'Hoje não está disponível' : 'Sem vagas hoje',
          message: quoteToday
            ? this.todayBlockLabel()
            : 'O auto check-in só é permitido quando há vagas disponíveis no dia.',
          duration: 8000,
          showClose: true,
          type: 'warning',
        })
      })
    },

    unblockAutoCheckinReservation() {
      this.autoCheckinBlockNotified = false
      this.$emit('blockReservation', false)
      this.$nextTick(() => {
        this.$set(this.form, 'auto_checkin_blocked', false)
      })
    },

    formattedDate(date, format, isTime) {
      if (isTime) {
        var now = `${moment().format('YYYY-MM-DD')} ${date}`
        return moment(now).format(format)
      } else {
        return moment(date).format(format)
      }
    },

    disabledDates(dateTime) {
      if (this.isReservationManager) return false
      let isBlocked = false
      if (
        // it's not in available dates
        this.availableDates[dateTime] == undefined ||
        // it's a old date
        moment(dateTime).isBefore(moment(), 'day') ||
        // it's NOT in special_price range
        !(
          moment(dateTime).isSameOrAfter(
            this.days_in_advance_avaiability.date_in_advance
          ) &&
          moment(dateTime).isSameOrBefore(
            this.days_in_advance_avaiability.date_from_today
          )
        )
      ) {
        isBlocked = true
      }
      return isBlocked
    },

    getAvailableDates() {
      let extraBlockedDates = []
      this.availableDates = {}
      let availableDates = {}

      if (this.form.atrativo.availability) {
        var currentSpecialPrice = this.form.atrativo.special_prices[0].find(
          (price) => price.slug == this.form.booking_slug
        )
        var days_from_today = Number(currentSpecialPrice.days_from_today)
        var date_from_today = moment()
          .add(days_from_today, 'days')
          .format('YYYY-MM-DD')
        var days_in_advance = Number(currentSpecialPrice.days_in_advance)
        var firstDayOfCurrentSpecialPrice = moment().add(
          days_in_advance - 1,
          'days'
        ) //Previous date before the selected day from month first day
        var daysInInterval = moment(date_from_today).diff(
          firstDayOfCurrentSpecialPrice,
          'days'
        )
        var vm = this

        //Fills the daysInInterval array with the first to the last day of limit date
        daysInInterval = Array(daysInInterval)
          .fill(0)
          .map((_, i) =>
            firstDayOfCurrentSpecialPrice
              .add(1, 'days')
              .clone()
              .format('YYYY-MM-DD')
          )

        Object.entries(this.form.atrativo.availability).map(function (
          value,
          index
        ) {
          const weekdayName = value[0].toLowerCase()
          const weekdayIndex = vm.daysOfWeek.indexOf(weekdayName) // Week index of value[0] date

          daysInInterval.map(function (day, idx) {
            // If the day in month is from the same day name (sunday, monday, etc) as the value[0] date
            if (weekdayIndex == moment(day).weekday()) {
              availableDates[day] = JSON.parse(JSON.stringify(value[1]))
            }
          })
        })

        // dates bloqued by time or tickets
        extraBlockedDates = Object.keys(this.unavailableDates).filter(
          (date) => {
            if (this.unavailableDates[date] == undefined) {
              return false
            } else {
              let sigle_ticket_blocked = false
              if (this.form.tickets.length == 1) {
                sigle_ticket_blocked = this.form.tickets[0].id
              }

              let extraBlockedDate = this.unavailableDates[date].filter(
                (condition) =>
                  condition.start == '*' ||
                  condition.ticket == '*' ||
                  condition.ticket == sigle_ticket_blocked ||
                  condition.slug == vm.form.booking_slug
              )
              if (Object.keys(extraBlockedDate).length) {
                return true
              }
            }
            return false
          }
        )

        // dates bloqued by capacity
        Object.keys(availableDates).forEach((date) => {
          availableDates[date].forEach((time, idx) => {
            if (this.getDateCapacity(time, date) === 0) {
              delete availableDates[date][idx]
            }
          })
          availableDates[date] = availableDates[date].filter((item) => item)
          if (availableDates[date].length === 0) {
            extraBlockedDates.push(date)
          }
        })
      }

      this.availableDates = Object.keys(availableDates)
        .filter((date) => extraBlockedDates.indexOf(date) < 0)
        .sort()
        .reduce((item, key) => {
          item[key] = availableDates[key]
          return item
        }, {})
      this.availabilityLoaded = true
    },

    getUnavailableDates() {
      this.unavailableDates = {}
      let unavailableDates = {}
      if (this.form.atrativo.unavailability) {
        var currentSpecialPrice = this.form.atrativo.special_prices[0].find(
          (price) => price.slug == this.form.booking_slug
        )
        var days_from_today = Number(currentSpecialPrice.days_from_today)
        var date_from_today = moment()
          .add(days_from_today, 'days')
          .format('YYYY-MM-DD')
        var days_in_advance = Number(currentSpecialPrice.days_in_advance)
        var firstDayOfCurrentSpecialPrice = moment().add(
          days_in_advance - 1,
          'days'
        ) //Previous date before the selected day from month first day
        var daysInInterval = moment(date_from_today).diff(
          firstDayOfCurrentSpecialPrice,
          'days'
        )
        var vm = this

        //Fills the daysInInterval array with the first to the last day of limit date
        daysInInterval = Array(daysInInterval)
          .fill(0)
          .map((_, i) =>
            firstDayOfCurrentSpecialPrice
              .add(1, 'days')
              .clone()
              .format('YYYY-MM-DD')
          )

        Object.entries(this.form.atrativo.unavailability).map(function (
          value,
          index
        ) {
          if (moment(value[0]).isValid()) {
            if (unavailableDates[value[0]] == undefined) {
              unavailableDates[value[0]] = []
            }
            unavailableDates[value[0]] = [
              ...unavailableDates[value[0]],
              ...value[1],
            ]
          } else {
            const weekdayName = value[0].toLowerCase()
            const weekdayIndex = vm.daysOfWeek.indexOf(weekdayName) // Week index of value[0] date

            daysInInterval.map(function (day, idx) {
              // If the day in month is from the same day name (sunday, monday, etc) as the value[0] date
              if (weekdayIndex == moment(day).weekday()) {
                if (unavailableDates[day] == undefined) {
                  unavailableDates[day] = []
                }
                unavailableDates[day] = [...unavailableDates[day], ...value[1]]
              }
            })
          }
        })
      }
      this.unavailableDates = unavailableDates
    },

    getDateCapacity(horary, date) {
      var vm = this
      if (date == undefined) {
        date = this.form.date
      }
      if (this.form.atrativo && this.form.atrativo.capacity) {
        let dateCapacity = {}

        let avaiableDates = Object.entries(this.form.atrativo.capacity).filter(
          (cap) => moment(cap[0]).isValid()
        )
        avaiableDates = avaiableDates
          .map(function (value, index) {
            let dates = Object.entries(value[1])

            dates = dates.map(function (val, idx) {
              let date = val[0].split(' ')[0]
              let time = val[0].split(' ')[1]
              if (date != undefined && time != undefined) {
                dateCapacity = {
                  date: date,
                  time: time,
                  available: Number(val[1].available),
                  booked: Number(val[1].booked),
                }
              }
              return dateCapacity
            })
            return dates
          })
          .flat()
          .filter((i) => Object.keys(i).length !== 0)

        let capacityByDate = this.groupBy(avaiableDates, (item) => item.date)
        var capacity = ''
        capacityByDate.map(function (value, index) {
          if (value[0] == date) {
            value[1].map(function (val, idx) {
              if (val.time == horary.start) {
                capacity = val.available
              }
            })
          }
        })

        return capacity
      } else {
        return ''
      }
    },

    selectHorary(horary, index) {
      if (this.form.time.length > 0 && this.form.time == horary.start) {
        this.form.time = ''
        this.pinnedPastStart = ''
      } else {
        this.form.time = horary.start
        this.pinnedPastStart =
          this.isReservationManager && this.isPastHorary(horary)
            ? horary.start
            : ''
      }
    },

    //METHOD TO GROUP BY KEYGETTER.
    //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
    groupBy(list, keyGetter) {
      const map = new Map()
      list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)

        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })
      return Array.from(map)
    },
  },

  mounted() {
    this.form.date = this.isConfirmedDeparture()
      ? moment(this.form.booking_date).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD')

    if (this.form.date.length > 0) {
      this.getUnavailableDates()
      this.getAvailableDates()
    }

    if (this.isAutoCheckinMode()) {
      this.HIDE_CALENDAR = true
    }
  },
}
</script>

<style>
.form-control {
  border: none;
}

.horary-scroll {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 8px;
  margin-right: -16px;
}

.horary-scroll::-webkit-scrollbar {
  height: 6px;
}

.horary-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
/*
[aria-disabled="true"] > span {
    color: red !important;
}
*/
</style>
